import React from 'react';
import styled from '@emotion/styled';
import { ArrowLink } from '../../../../../ui';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { PARKING_ADD_GUEST_BOOKING_HASH_PATTERN } from '../guest-booking/AddGuestBookingDialogRoute';
import { useUrlForPageId } from '../../../../app/pages/ui/utils/useUrlForPageId';
import { ParkingPageId } from '../../../domain/pages/ParkingPageId';
import Responsive from '../../../../../ui/utils/Responsive';

export const StyledMyBookingsHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
	margin-bottom: 24px;

	h2 {
		margin-bottom: 0;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: flex;
		margin-bottom: 8px;
	}
`;

const AddGuestBookingLink = styled.a`
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: none;
	}
`;

const StyledAsideMyBookingsHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 24px;
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		gap: 10px;
	}
`;
interface IMyBookingsHeaderProps {
	number?: number;
	showViewAll?: boolean;
	showRetrieveAsGuest?: boolean;
}
const MyBookingsHeader = ({
	number,
	showViewAll,
	showRetrieveAsGuest,
}: IMyBookingsHeaderProps) => {
	const { t } = useTranslation();
	const bookingsLink = useUrlForPageId(ParkingPageId.ParkingBookings);

	return (
		<StyledMyBookingsHeader>
			<StyledAsideMyBookingsHeader>
				<h2>{t('parking_landing_your_bookings_title')}</h2>
				{!!number && <h2>({number})</h2>}
			</StyledAsideMyBookingsHeader>
			<StyledAsideMyBookingsHeader>
				{showRetrieveAsGuest && (
					<AddGuestBookingLink href={PARKING_ADD_GUEST_BOOKING_HASH_PATTERN}>
						{'+ '}
						{t('parking_landing_your_bookings_retrieve_button')}
					</AddGuestBookingLink>
				)}
				{showViewAll && (
					<ArrowLink href={bookingsLink}>{t('web_view_all_label')}</ArrowLink>
				)}
			</StyledAsideMyBookingsHeader>
		</StyledMyBookingsHeader>
	);
};

export { MyBookingsHeader };
